// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__2QenD","breadcrumbLink":"Breadcrumb_breadcrumbLink__3gpe-","currentLink":"Breadcrumb_currentLink__10lj1","divider":"Breadcrumb_divider__3Zs-Q"};